'use client'

import useOrganisationContext from '../context/useOrganisationContext'
import BaseSurfaceRounded from '~/components/layout/BaseSurfaceRounded'
import EditSectionTitle from '~/components/layout/EditSectionTitle'
import {SoftwareQualityOverviewProvider} from './SoftwareQualityOverviewContext'
import {OrganisationSoftwareQualityOverview} from './OrganisationSoftwareQualityOverview'
import SoftwareIndicatorYearDropdown from '~/components/software/indicator/SoftwareIndicatorYearDropdown'
import {useEffect, useState} from 'react'
import {useSoftwareIndicatorEvaluationPeriods} from '~/components/software/indicator/useSoftwareIndicatorEvaluationPeriods'
import Stack from '@mui/material/Stack'
import ProtectedContent from '~/components/layout/ProtectedContent'
import {useSession} from '~/auth/AuthProvider'
import PageErrorMessage from '~/components/layout/PageErrorMessage'
import UserAgreementModal from '~/components/user/settings/agreements/UserAgreementModal'
import Verified from '@mui/icons-material/Verified'
import HgfButton from '~/components/home/helmholtz/ui/HgfButton'
import AssociatedPoFTopicsDialog from './AssociatedPoFTopicsDialog'

export default function SoftwareQualityIndicatorOrganisationSettings() {
  const {id, isMaintainer, is_tenant} = useOrganisationContext()
  const {user, status} = useSession()
  const {latestPeriod, evaluationPeriods} = useSoftwareIndicatorEvaluationPeriods()
  const [evaluationPeriod, setEvaluationPeriod] = useState<string>('')
  const [associatedPoFTopicDialogIsOpen, setAssociatedPoFTopicDialogIsOpen] = useState<boolean>(false)

  useEffect(() => {
    setEvaluationPeriod(latestPeriod ?? '')
  }, [latestPeriod])

  if (!is_tenant) return (<PageErrorMessage
    status={404}
    message='Not Found'
  />)

  return (
    <ProtectedContent
      status={status}
      role={user?.role}
      isMaintainer={isMaintainer}
    >
      <UserAgreementModal />
      <BaseSurfaceRounded
        className="flex-1 flex flex-col mb-12 p-4"
        type="section"
      >
        <EditSectionTitle
          title='Helmholtz Software Quality Indicator'
          subtitle='Overview of Software Quality Evaluations'
        >
          <Stack direction='row' className='gap-4 pb-4'>
            <HgfButton style='secondary' size='small' onClick={() => setAssociatedPoFTopicDialogIsOpen(true)}>
              <Verified/>
              Associated PoF Topics
            </HgfButton>
            <SoftwareIndicatorYearDropdown selectedYear={evaluationPeriod} setYear={setEvaluationPeriod} />
          </Stack>
        </EditSectionTitle>
        <SoftwareQualityOverviewProvider organisationId={id} year={evaluationPeriod}>
          {associatedPoFTopicDialogIsOpen && (<AssociatedPoFTopicsDialog year={evaluationPeriod} open={associatedPoFTopicDialogIsOpen} onClose={() => setAssociatedPoFTopicDialogIsOpen(false)}/>)}
          <OrganisationSoftwareQualityOverview />
        </SoftwareQualityOverviewProvider>
      </BaseSurfaceRounded>
    </ProtectedContent>
  )
}
